<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="query-form">
      <el-form inline>
        <el-form-item label="SKUID">
          <el-input v-model="queryForm.skuId" clearable></el-input>
        </el-form-item>
        <div style="float: right">
          <el-button @click="search" type="primary">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </div>
      </el-form>
    </div>

    <div>
      <el-button type="primary" @click="showImportDialog">导入商品</el-button>
      <el-button type="primary" @click="exportProduct">导出商品</el-button>
      <el-button
        type="primary"
        @click="batchDelete"
        :disabled="selection.length === 0"
        >删除</el-button
      >
      <el-button type="primary" @click="deleteAll">全部清空</el-button>
    </div>
    <p class="shuoming" style="margin-bottom: 20px">
      <i class="el-icon-warning" style="color: #0072c6"></i
      >&nbsp;&nbsp;注：折扣均以off形式显示
    </p>
    <el-table :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="45"></el-table-column>
      <el-table-column prop="skuId" label="SKU ID"></el-table-column>
      <el-table-column prop="discount" label="折扣"></el-table-column>
    </el-table>
    <el-pagination
      class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.current"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <el-dialog
      :visible="dialogVisible"
      title="导入商品"
      :show-close="false"
      width="40%"
    >
      <div>
        <p class="shuoming" style="margin-bottom: 20px">
          <i class="el-icon-warning" style="color: #0072c6"></i
          >&nbsp;&nbsp;注：商品以增量方式导入
        </p>
        <oss-upload
          ref="ossUpload"
          @submitSuccess="submitSuccess"
          :ossUploadParams="ossUploadParams"
        ></oss-upload>
      </div>
      <div slot="footer">
        <el-button @click="cancelDialog">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getPromotionSkuList,
  exportPromotionSkuList,
  delAllPromotionSku,
  delPromotionSku,
} from "../api.js";

import { downloadUrlFile } from "@/utils/functions";
import ossUpload from "./ossUpload/ossUpload";
export default {
  data() {
    return {
      fullscreenLoading: false,
      queryForm: {
        skuId: null,
        current: 1,
        size: 25,
      },
      tableData: [],
      total: 0,
      selection: [],
      dialogVisible: false,
      ossUploadParams: {
        salesPromotionId: this.$route.query.salesPromotionId,
        vendorId: this.$route.query.vendorId,
        importText: "设置任务已提交。请稍后前往任务管理查看是否导入成功”",
        noRoundRobin: false,
        templateUrl: `/basic-backend/promotion/sku/discount/template/download`,
        uploadType: "csv",
        analyzeFileUrl: `/basic-backend/promotion/sku/discount/analyze-file`,
        analyzeResultUrl: `/basic-backend/promotion/sku/discount/analyze-result`,
        submitFileUrl: `/basic-backend/promotion/sku/discount/submit-file`,
        specialCodeStatus: true, //特殊状态 返回值500
      },
    };
  },
  components: { ossUpload },
  created() {},
  mounted() {
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.current = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.skuId = null;
      this.queryForm.current = 1;
      this.getTableData();
    },
    getTableData() {
      getPromotionSkuList(
        this.$route.query.salesPromotionId,
        this.$route.query.vendorId,
        this.queryForm
      ).then((res) => {
        if (res.data) {
          this.total = res.data.total;
          this.tableData = res.data.records;
        }
      });
    },
    handleSizeChange(size) {
      this.queryForm.size = size;
      this.getTableData();
    },
    handleCurrentChange(current) {
      this.queryForm.current = current;
      this.getTableData();
    },
    batchDelete() {
      if (this.selection.length === 0) {
        this.$message("请选择商品");
        return;
      }
      this.$confirm("是否确认删除？", "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let params = {
            ids: this.selection.map((item) => item.salesPromotionVendorSkuDiscountId),
          };
          this.submitBatchDelete(params);
        })
        .catch(() => {});
    },
    submitBatchDelete(params) {
      this.loading = true;
      delPromotionSku(
        this.$route.query.salesPromotionId,
        this.$route.query.vendorId,
        params.ids
      ).then((res) => {
        if (res && res.success) {
          this.$message.success("删除成功");
          this.getTableData();
        } else {
          this.loading = false;
          this.$message.error((res && res.message) || "系统异常");
        }
      });
    },
    deleteAll() {
      this.$confirm("是否全部清空？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          delAllPromotionSku(
            this.$route.query.salesPromotionId,
            this.$route.query.vendorId
          ).then((res) => {
            if (res && res.success) {
              this.$message.success("全部清空");
              this.getTableData();
            } else {
              this.loading = false;
              this.$message.error((res && res.message) || "系统异常");
            }
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    showImportDialog() {
      this.dialogVisible = true;
    },
    cancelDialog() {
      this.dialogVisible = false;
      this.$refs.ossUpload.removefile();
    },
    submitSuccess() {
      this.dialogVisible = false;
      this.getTableData();
    },
    exportProduct() {
      this.fullscreenLoading = true;
      exportPromotionSkuList(
        this.$route.query.salesPromotionId,
        this.$route.query.vendorId
      ).then((res) => {
        if (res && res.success) {
          this.$message.success("导出任务已提交，请稍后前往任务管理下载文件")
        }
        this.fullscreenLoading = false;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
</style>
